module.exports = __webpack_public_path__ + "static/img/global_app_access_img_1.3e18ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_app_access_img_1.jpg
// module id = LB2U
// module chunks = 0